import React from 'react'

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@material-ui/core'

import './index.scss'

class OldMessageViewer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {}
    }

    render() {
        return (
            <div className='OldMessageViewer'>
                <Dialog
                    open={true}
                    onClose={() => {
                        this.props.OldMessageViewerClose()
                    }}
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                >
                    <DialogTitle id='alert-dialog-title'>
                        Old Message
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id='oldmessage-text'>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: this.props.oldMessage,
                                }}
                            />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                this.props.OldMessageViewerClose()
                            }}
                            color='primary'
                            autoFocus
                        >
                            Got it
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default OldMessageViewer
